import {
    GET_ALERT_LOG_DETAILS,
    GET_ALERT_LOG_DETAILS_FAIL,
    GET_ALERT_LOG_DETAILS_SUCCESS,
    GET_ALERT_LOGS,
    GET_ALERT_LOGS_FAIL,
    GET_ALERT_LOGS_SUCCESS,
    POST_ACKNOWLEDGE_ALERT,
    POST_ACKNOWLEDGE_ALERT_FAIL,
    POST_ACKNOWLEDGE_ALERT_SUCCESS,
    POST_RESOLVE_ALERT,
    POST_RESOLVE_ALERT_FAIL,
    POST_RESOLVE_ALERT_SUCCESS,
    SELECT_ALERT,
    SELECT_ALERT_BY_ID,
    GET_ALERT_LOGS_COUNT,
    GET_ALERT_LOGS_COUNT_FAIL,
    GET_ALERT_LOGS_COUNT_SUCCESS,
    GET_INTEGRATION_TYPES,
    GET_INTEGRATION_TYPES_FAIL,
    GET_INTEGRATION_TYPES_SUCCESS,
    GET_RUNBOOK,
    GET_RUNBOOK_FAIL,
    GET_RUNBOOK_SUCCESS,
    POST_RUNBOOK_FEEDBACK,
    POST_RUNBOOK_FEEDBACK_SUCCESS,
    POST_RUNBOOK_FEEDBACK_FAIL,
    GET_RUNBOOK_FEEDBACKS,
    GET_RUNBOOK_FEEDBACKS_SUCCESS,
    GET_RUNBOOK_FEEDBACKS_FAIL,
    POST_RUNBOOK,
    POST_RUNBOOK_FAIL,
    POST_RUNBOOK_SUCCESS,
    UPDATE_RUNBOOK,
    UPDATE_RUNBOOK_FAIL,
    UPDATE_RUNBOOK_SUCCESS,
    GET_ALERT_CORRELATION,
    GET_ALERT_CORRELATION_SUCCESS,
    GET_ALERT_CORRELATION_FAIL,
    GET_ERROR_LOGS,
    GET_ERROR_LOGS_SUCCESS,
    GET_ERROR_LOGS_FAIL,
    GET_METRIC_DATA_BY_ALERT_LOG_ID,
    GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS,
    GET_METRIC_DATA_BY_ALERT_LOG_ID_FAIL,
    GET_RUNBOOK_BY_RUNBOOK_ID,
    GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS,
    GET_RUNBOOK_BY_RUNBOOK_ID_FAIL,
    GET_ALERT_LOG_STATUS_HISTORY,
    GET_ALERT_LOG_STATUS_HISTORY_SUCCESS,
    GET_ALERT_LOG_STATUS_HISTORY_FAIL,
    GET_RUNBOOK_RESULTS_ALERT_LOG_ID,
    GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS,
    GET_RUNBOOK_RESULTS_ALERT_LOG_ID_FAIL,
    EXECUTE_RUNBOOK_STEP,
    EXECUTE_RUNBOOK_STEP_SUCCESS,
    EXECUTE_RUNBOOK_STEP_FAIL,
    START_AI_CONVERSATION,
    START_AI_CONVERSATION_SUCCESS,
    START_AI_CONVERSATION_FAIL,
    GET_AI_RESPONSE,
    GET_AI_RESPONSE_SUCCESS,
    GET_AI_RESPONSE_FAIL,
    UPDATE_AI_RESPONSE_CHUNK,
    SET_AI_STREAMING,
    CLEAR_AI_RESPONSE,
    GET_PAST_AI_CONVERSATION,
    GET_PAST_AI_CONVERSATION_SUCCESS,
    GET_PAST_AI_CONVERSATION_FAIL,
    GET_AGENT_AVAILABILITY_FOR_ALERT_LOG,
    GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS,
    GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_FAIL,
    GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID,
    GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS,
    GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_FAIL,
    HANDLE_APPROVAL_MESSAGE,
    SEND_APPROVAL_DECISION, SEND_APPROVAL_DECISION_SUCCESS, SEND_APPROVAL_DECISION_FAIL
} from "./actionTypes";

export const selectAlert = alert => ({
    type: SELECT_ALERT,
    payload: alert
})

export const selectAlertByID = alertId => ({
    type: SELECT_ALERT_BY_ID,
    payload: alertId
})

export const getAlertLogs = (pageFilters) => ({
    type: GET_ALERT_LOGS,
    payload: {pageFilters}
})

export const getAlertLogsSuccess = alertLogs => ({
    type: GET_ALERT_LOGS_SUCCESS,
    payload: alertLogs,
})

export const getAlertLogsFail = error => ({
    type: GET_ALERT_LOGS_FAIL,
    payload: error,
})

export const getAlertLogsCount = (pageFilters) => ({
    type: GET_ALERT_LOGS_COUNT,
    payload: {pageFilters}
})

export const getAlertLogsCountSuccess = alerts_log_count => ({
    type: GET_ALERT_LOGS_COUNT_SUCCESS,
    payload: alerts_log_count,
})

export const getAlertLogsCountFail = error => ({
    type: GET_ALERT_LOGS_COUNT_FAIL,
    payload: error,
})

export const getIntegrationTypes = () => ({
    type: GET_INTEGRATION_TYPES,
})

export const getIntegrationTypesSuccess = (integrationTypes) => ({
    type: GET_INTEGRATION_TYPES_SUCCESS,
    payload: integrationTypes,
})

export const getIntegrationTypesFail = error => ({
    type: GET_INTEGRATION_TYPES_FAIL,
    payload: error,
})

export const postAcknowledgeAlert = (alertIds) => ({
    type: POST_ACKNOWLEDGE_ALERT,
    payload: {alertIds}
})

export const postAcknowledgeAlertSuccess = alertIds => ({
    type: POST_ACKNOWLEDGE_ALERT_SUCCESS,
    payload: alertIds,
})

export const postAcknowledgeAlertFail = error => ({
    type: POST_ACKNOWLEDGE_ALERT_FAIL,
    payload: error,
})

export const postResolveAlert = (alertIds) => ({
    type: POST_RESOLVE_ALERT,
    payload: {alertIds}
})

export const postResolveAlertSuccess = alertIds => ({
    type: POST_RESOLVE_ALERT_SUCCESS,
    payload: alertIds,
})

export const postResolveAlertFail = error => ({
    type: POST_RESOLVE_ALERT_FAIL,
    payload: error,
})

export const getAlertLogDetails = (alertId) => ({
    type: GET_ALERT_LOG_DETAILS,
    payload: {alertId}
})

export const getAlertLogDetailsSuccess = alertLogDetails => ({
    type: GET_ALERT_LOG_DETAILS_SUCCESS,
    payload: alertLogDetails,
})

export const getAlertLogDetailsFail = error => ({
    type: GET_ALERT_LOG_DETAILS_FAIL,
    payload: error,
})

export const getRunbook = (alert_id) => ({
    type: GET_RUNBOOK,
    payload: {alert_id}
})

export const getRunbookSuccess = runbookDetails => ({
    type: GET_RUNBOOK_SUCCESS,
    payload: runbookDetails
})

export const getRunbookFail = error => ({
    type: GET_RUNBOOK_FAIL,
    payload: error
})

export const postRunbookFeedback = (data) => ({
    type: POST_RUNBOOK_FEEDBACK,
    payload: {data}
})

export const postRunbookFeedbackSuccess = (data) => ({
    type: POST_RUNBOOK_FEEDBACK_SUCCESS,
    payload: {data}
})

export const postRunbookFeedbackFail = error => ({
    type: POST_RUNBOOK_FEEDBACK_FAIL,
    payload: error
})

export const postRunbook = (data) => ({
    type: POST_RUNBOOK,
    payload: {data}
})

export const postRunbookSuccess = (data) => ({
    type: POST_RUNBOOK_SUCCESS,
    payload: {data}
})

export const postRunbookFail = error => ({
    type: POST_RUNBOOK_FAIL,
    payload: error
})

export const updateRunbook = (data, id) => ({
    type: UPDATE_RUNBOOK,
    payload: {data, id}
})

export const updateRunbookSuccess = (data) => ({
    type: UPDATE_RUNBOOK_SUCCESS,
    payload: {data}
})

export const updateRunbookFail = error => ({
    type: UPDATE_RUNBOOK_FAIL,
    payload: error
})

export const getRunbookFeedbacks = (runbook_id) => ({
    type: GET_RUNBOOK_FEEDBACKS,
    payload: {runbook_id}
})

export const getRunbookFeedbacksSuccess = (feedbacks) => ({
    type: GET_RUNBOOK_FEEDBACKS_SUCCESS,
    payload: feedbacks
})

export const getRunbookFeedbackFail = error => ({
    type: GET_RUNBOOK_FEEDBACKS_FAIL,
    payload: error
})

export const getAlertCorrelation = (alertId) => ({
    type: GET_ALERT_CORRELATION,
    payload: {alertId}
})

export const getAlertCorrelationSuccess = alertCorrelation => ({
    type: GET_ALERT_CORRELATION_SUCCESS,
    payload: alertCorrelation,
})

export const getAlertCorrelationFail = error => ({
    type: GET_ALERT_CORRELATION_FAIL,
    payload: error,
})

export const getErrorLogs = (alertId) => ({
    type: GET_ERROR_LOGS,
    payload: {alertId}
})

export const getErrorLogsSuccess = errorLogs => ({
    type: GET_ERROR_LOGS_SUCCESS,
    payload: errorLogs,
})

export const getErrorLogsFail = error => ({
    type: GET_ERROR_LOGS_FAIL,
    payload: error,
})

export const getMetricDataByAlertLogId = (alertId) => ({
    type: GET_METRIC_DATA_BY_ALERT_LOG_ID,
    payload: {alertId}
})

export const getMetricDataByAlertLogIdSuccess = (data) => ({
    type: GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS,
    payload: data,
})

export const getMetricDataByAlertLogIdFail = error => ({
    type: GET_METRIC_DATA_BY_ALERT_LOG_ID_FAIL,
    payload: error,
})


export const getRunbookByRunbookId = (runbookId) => {
    return {
        type: GET_RUNBOOK_BY_RUNBOOK_ID,
        payload: {runbookId}
    };
}
export const getRunbookByRunbookIdSuccess = (data) => ({
    type: GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS,
    payload: data
})

export const getRunbookByRunbookIdFail = error => ({
    type: GET_RUNBOOK_BY_RUNBOOK_ID_FAIL,
    payload: error,
})

export const getAlertLogStatusHistory = (alertId) => ({
    type: GET_ALERT_LOG_STATUS_HISTORY,
    payload: {alertId}
})

export const getAlertLogStatusHistorySuccess = (data) => ({
    type: GET_ALERT_LOG_STATUS_HISTORY_SUCCESS,
    payload: data
})

export const getAlertLogStatusHistoryFail = error => ({
    type: GET_ALERT_LOG_STATUS_HISTORY_FAIL,
    payload: error,
})


export const getRunbookStepsResultsByAlertLogId = (alertId) => ({
    type: GET_RUNBOOK_RESULTS_ALERT_LOG_ID,
    payload: {alertId}
})

export const getRunbookStepsResultsByAlertLogIdSuccess = (data) => ({
    type: GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS,
    payload: data,
})

export const getRunbookStepsResultsByAlertLogIdFail = error => ({
    type: GET_RUNBOOK_RESULTS_ALERT_LOG_ID_FAIL,
    payload: error,
})

export const executeRunbookStep = (data) => ({
    type: EXECUTE_RUNBOOK_STEP,
    payload: {data}
})

export const executeRunbookStepSuccess = (data) => ({
   type: EXECUTE_RUNBOOK_STEP_SUCCESS,
   payload: {data}
})

export const executeRunbookStepFail = error => ({
    type: EXECUTE_RUNBOOK_STEP_FAIL,
    payload: error
})

export const startAiConversation = (data) => ({
    type: START_AI_CONVERSATION,
    payload: data
})

export const startAiConversationSuccess = (data) => ({
    type: START_AI_CONVERSATION_SUCCESS,
    payload: data
})

export const startAiConversationFail = error => ({
    type: START_AI_CONVERSATION_FAIL,
    payload: error
})


export const getAiResponse = (payload) => ({
    type: GET_AI_RESPONSE,
    payload: payload
})
export const getAiResponseSuccess = (data) => ({
    type: GET_AI_RESPONSE_SUCCESS,
    payload: data
})
export const getAiResponseFail = error => ({
    type: GET_AI_RESPONSE_FAIL,
    payload: error
})

// Add these new actions
export const updateAiResponseChunk = (chunk) => ({
    type: UPDATE_AI_RESPONSE_CHUNK,
    payload: chunk
});

export const setAiStreaming = (isStreaming) => ({
    type: SET_AI_STREAMING,
    payload: isStreaming
});

export const clearAiResponse = () => ({
    type: CLEAR_AI_RESPONSE
});

export const getPastAiConversations = (alertLogId) => ({
    type: GET_PAST_AI_CONVERSATION,
    payload: alertLogId
})

export const getPastAiConversationsSuccess = (data) => ({
    type: GET_PAST_AI_CONVERSATION_SUCCESS,
    payload: data
})

export const getPastAiConversationsFail = error => ({
    type: GET_PAST_AI_CONVERSATION_FAIL,
    payload: error
})

export const getAgentAvailable = (alertLogId) => ({
    type: GET_AGENT_AVAILABILITY_FOR_ALERT_LOG,
    payload: alertLogId
})

export const getAgentAvailableSuccess = (data) => ({
    type: GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS,
    payload: data
})
export const getAgentAvailableFail = error => ({
    type: GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_FAIL,
    payload: error
})



export const getUserExecutedStepsResultsByAlertLogId = (alertId) => ({
    type: GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID,
    payload: alertId
})

export const getUserExecutedStepsResultsByAlertLogIdSuccess = (data) => ({
    type: GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS,
    payload: data,
})

export const getUserExecutedStepsResultsByAlertLogIdFail = error => ({
    type: GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_FAIL,
    payload: error,
})

export const handleApprovalMessage = (data) => {
    return {
        type: HANDLE_APPROVAL_MESSAGE,
        payload: data
    }
}

export const sendApprovalDecision = (data) => ({
    type: SEND_APPROVAL_DECISION,
    payload: data
})
